import React, {useEffect} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import ActionCreators from '../actions'

let instanceCart

const AddProductButton = props => {

  const {attrs, addbutton} = props
  const product_id = attrs.getNamedItem('data-product-id').value
  const button_enabled = (addbutton.max_quantity > addbutton.quantity) && (addbutton.status === "READY")

  const addToCart = () => {

    if((instanceCart)&&(button_enabled)){

        let addEvent = new CustomEvent("NcartAddItem", {detail: {"app": "product", "id": product_id, "quantity": 1, "data": {}}});
        document.dispatchEvent(addEvent);

    }
    // todo: loader
    console.log("props", props);
  };

  useEffect(() => {
    console.log("useEffect", product_id);
    const in_stock = parseInt(attrs.getNamedItem('data-in-stock').value)
    props.setInitialData({max_quantity: in_stock})

    function handleUpdateInCart(event) {

      let allitems = event.detail || []
      let current_product = allitems.find(function(element){

        return element.sku === product_id

      });

      if(current_product){

        props.setInitialData({quantity: current_product.quantity});

      }else{

        props.setInitialData({quantity: 0});

      }
    }

    document.addEventListener("NcartInCartUpdated", handleUpdateInCart);

    const getCartData = () => {

      const interval = setInterval(() => {
        instanceCart = window._global_singleton_instance["ncart"];
        console.log("instanceCart", instanceCart);
        if (instanceCart) {

          clearInterval(interval);

        }
      }, 1000);

      return () => {
          document.removeEventListener("NcartInCartUpdated", handleUpdateInCart);
      };

    };

    getCartData();

  }, []);

  return (
      <button className={button_enabled ? "ncart-add-button enabled": "ncart-add-button disabled"} onClick={() => addToCart()}>
        { addbutton.status === "LOADING" ? (
          <div className="ncart-add-button-loader">
          <div className="preloader pl-size-xs">
            <div className="spinner-layer pl-red-grey">
              <div className="circle-clipper left">
                <div className="circle"></div>
              </div>
              <div className="circle-clipper right">
                <div className="circle"></div>
              </div>
            </div>
          </div>
        </div>
        ): (
        <i className="material-icons">shopping_cart</i>
        ) }
        <span className="ncart-add-button-title">Добавить в корзину</span>
        {addbutton.quantity > 0 ? (<span className="ncart-add-button-badge">{addbutton.quantity}</span>): null }
      </button>
  )
};


const mapStateToProps = state => ({
  addbutton: state.addbutton
});

const mapDispatchToProps = dispatch => bindActionCreators(ActionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddProductButton);